<template>
    <footer class="bg-white w-full py-6 mt-auto md:py-4 xl:py-6 desktop:z-20" id="page-footer">
        <div class="font-family-light footer-container m-0 mx-auto flex flex-col-reverse items-center sm:flex-row sm:justify-between">
            <div class="text-center sm:text-left mt-4 sm:mt-0 sm:mr-4 copyright">
                Copyright © {{ (new Date().getFullYear()) }} Intus Windows LLC. <br class="sm:hidden all-rights-break">All rights Reserved.
            </div>
            <div class="flex items-center text-center shrink-0">
                <div class="phone"><a href="tel:+18883809940">1 (888) 380-9940</a></div>
                <span class="mx-3 vertical_line">|</span>
                <div class="contact_us">
                    <a href="https://www.intuswindows.com/contact-us" target="_blank" class="outbound-link">Contact Us</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>

</script>
